import { Link as RouterLink } from "react-router-dom";
import { Link, Stack, Typography } from "@mui/material";

import { PATH_AUTH } from "../../routes/paths";
import AuthLoginForm from "./AuthLoginForm";
import AuthOnboardingLayout from "./AuthOnboardingLayout";

// ----------------------------------------------------------------------

export default function Login() {
  return (
    <AuthOnboardingLayout
      heroTitle="Bem-vindo de volta."
      heroDescription="Entre na sua conta e continue seu atendimento com o Alfred."
      heroImageSrc="/assets/images/auth/alfred-login.png"
      heroImageAlt="Alfred dando boas-vindas"
      topContent={
        <Stack direction="row" spacing={0.75} alignItems="center">
          <Typography variant="body2" color="text.secondary">
            É sua primeira vez por aqui?
          </Typography>
          <Link
            component={RouterLink}
            to={PATH_AUTH.register}
            variant="subtitle2"
          >
            Crie sua conta
          </Link>
        </Stack>
      }
      footer="Seus dados são protegidos e usados somente para operar sua conta Alfred."
    >
      <Stack spacing={3}>
        <div>
          <Typography variant="h4" sx={{ mb: 1 }}>
            Faça seu login
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Informe seu e-mail e senha.
          </Typography>
        </div>

        <AuthLoginForm />
      </Stack>
    </AuthOnboardingLayout>
  );
}
